import "./App.css";
import Testimonials from "./testimonials/testimonials";
function App() {
  return (
    <>
      <main className="main">
        <Testimonials />
      </main>
    </>
  );
}

export default App;
